import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";

// Carte « Ton du robot Messenger » (demande du propriétaire, 2026-10-08) : le style
// des réponses IA (professionnel / chaleureux / s'ajuste au client) et la signature
// ajoutée en bas de chaque réponse — réglables ici, appliqués aussitôt au robot.
const STYLES = [
  ["professionnel", "Professionnel et courtois (vouvoiement)"],
  ["chaleureux", "Chaleureux et proche du client (tutoiement)"],
  ["adapte", "S'ajuste au ton du client"],
];

export default function TonRobotCard() {
  const [style, setStyle] = useState("professionnel");
  const [signature, setSignature] = useState("— L'équipe Mr Trophée / The Mr Trophée Team");
  const [pret, setPret] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get("/admin/settings").then((r) => {
      if (!alive) return;
      if (r.data.bot_tone) setStyle(r.data.bot_tone);
      if (r.data.bot_signature != null) setSignature(r.data.bot_signature);
      setPret(true);
    }).catch(() => { if (alive) setPret(true); });
    return () => { alive = false; };
  }, []);

  return (
    <div className="bg-surface border border-ivory/10 rounded-xl p-7 mb-6" data-testid="ton-robot-card">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div>
          <p className="font-semibold">Ton du robot Messenger</p>
          <p className="text-xs text-ivory/70 mt-1">
            Style des réponses IA du robot d'accueil Facebook et signature ajoutée en bas
            de chaque réponse (laisser vide = aucune signature). Appliqué aussitôt.
          </p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <select data-testid="ton-robot-style" value={style} disabled={!pret}
            onChange={(e) => setStyle(e.target.value)}
            className="bg-ink border border-ivory/15 rounded-lg px-3 py-2 text-sm text-ivory [color-scheme:dark] focus:border-gold focus:outline-none transition-colors">
            {STYLES.map(([v, lab]) => <option key={v} value={v}>{lab}</option>)}
          </select>
          <input data-testid="ton-robot-signature" type="text" value={signature} disabled={!pret}
            onChange={(e) => setSignature(e.target.value)} maxLength={120}
            placeholder="— L'équipe Mr Trophée / The Mr Trophée Team"
            className="bg-ink border border-ivory/15 rounded-lg px-3 py-2 text-sm text-ivory w-72 max-w-full focus:border-gold focus:outline-none transition-colors" />
          <button type="button" data-testid="ton-robot-save"
            onClick={async () => {
              try {
                await api.patch("/admin/settings", { bot_tone: style, bot_signature: signature });
                toast.success("Ton du robot enregistré — les prochaines réponses IA l'utilisent");
              } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
            }}
            className="px-4 py-2 rounded-full text-sm bg-gold text-ink font-semibold hover:bg-champagne transition-colors">
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
}
